'use client';

import { type ReactElement } from 'react';
import Link from 'next/link';

import type TFunctionResult from 'i18next';

interface ILinkText {
  pathname: string;
  query?: { [key: string]: string } | 'undefined';
  locale?: string;
  classNames?: string;
  onClick?: () => void;
  children: ReactElement | number | string | typeof TFunctionResult;
  dataUITestClass?: string;
}

export const LinkTextAppFolder = ({
  pathname,
  query,
  locale,
  classNames,
  onClick,
  children,
  dataUITestClass,
}: ILinkText) => (
  <Link
    href={{
      pathname: pathname,
      query: query !== 'undefined' ? query : '',
    }}
    locale={locale}
    className={classNames}
    data-testid={dataUITestClass}
    onClick={onClick}
  >
    <>{children}</>
  </Link>
);

LinkTextAppFolder.displayName = 'LinkTextAppFolder';
